import { HOST_ACCESS } from 'store/constants'

export const getUserSlug = (user) => {
  return user.get('username') || user.get('id')
}

export const getIsUserAdmin = (user) =>
  user.get('hostAccess') === HOST_ACCESS.ADMIN
